// FIXME: As constantes aqui tem que estar em sincronia com as constantes definidas no backend

export const FILE_TYPES = ["image", "audio", "video", "document"] as const;
export type FileType = (typeof FILE_TYPES)[number];

/**
 * Allowlist única por mime (SA-1384 Task 12): a mesma allowlist da galeria
 * (`AgentGallery/constants.ts`, que importa daqui) e do backend
 * (`outboundFileValidationService.ts`). Inclui os apelidos que o
 * navegador/SO mandam para os MESMOS formatos (`audio/mp3`, `image/jpg` etc.)
 * para o seletor de arquivo do atendente não escondê-los; o backend traduz
 * para o mime canônico da Meta antes de enviar (`normalizeMediaMime`).
 */
export const MEDIA_KIND_BY_MIME: Record<string, FileType> = {
  "image/jpeg": "image",
  "image/png": "image",
  "video/mp4": "video",
  "video/3gpp": "video",
  "audio/mpeg": "audio",
  "audio/ogg": "audio",
  "audio/mp4": "audio",
  "audio/aac": "audio",
  "audio/amr": "audio",
  "application/pdf": "document",
  "application/msword": "document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "document",
  "application/vnd.ms-excel": "document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    "document",
  "application/vnd.ms-powerpoint": "document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    "document",
  "text/plain": "document",
  // Apelidos.
  "audio/mp3": "audio",
  "audio/x-mpeg": "audio",
  "audio/m4a": "audio",
  "audio/x-m4a": "audio",
  "audio/aacp": "audio",
  "image/jpg": "image",
  "application/x-pdf": "document",
};

const mimesOfKind = (kind: FileType): string[] =>
  Object.keys(MEDIA_KIND_BY_MIME).filter(
    (mime) => MEDIA_KIND_BY_MIME[mime] === kind
  );

export const DOCUMENT_MIMETYPES = mimesOfKind("document");
export const VIDEO_MIMETYPES = mimesOfKind("video");
export const AUDIO_MIMETYPES = mimesOfKind("audio");
export const IMAGE_MIMETYPES = mimesOfKind("image");

export const MAX_DOCUMENT_FILE_SIZE = 1024 ** 2 * 100; // 100MB in bytes
export const MAX_IMAGE_FILE_SIZE = 1024 ** 2 * 5; // 5MB in bytes
export const MAX_VIDEO_FILE_SIZE = 1024 ** 2 * 16; // 16MB in bytes
export const MAX_AUDIO_FILE_SIZE = 1024 ** 2 * 16; // 16MB in bytes

export const FILES_MAX_SIZES = {
  document: MAX_DOCUMENT_FILE_SIZE,
  image: MAX_IMAGE_FILE_SIZE,
  video: MAX_VIDEO_FILE_SIZE,
  audio: MAX_AUDIO_FILE_SIZE,
};

/**
 * Formatos aceitos em prosa, espelho de `ACCEPTED_FORMATS_LABEL` do backend
 * (`outboundFileValidationService.ts`). Alimenta a mensagem de "o WhatsApp não
 * aceita este formato" (SUP-498).
 */
export const ACCEPTED_FORMATS_LABEL =
  "PDF, Word, Excel, PowerPoint, texto (.txt), imagem (JPEG ou PNG), vídeo (MP4 ou 3GP) e áudio (MP3, OGG, M4A, AAC ou AMR)";

/**
 * Extensões dos formatos de `MEDIA_KIND_BY_MIME`; a extensão decide antes do
 * mime (SUP-498). Espelho de `ACCEPTED_EXTENSIONS` do backend
 * (`outboundFileValidationService.ts`).
 */
export const ACCEPTED_EXTENSIONS: ReadonlySet<string> = new Set([
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "txt",
  "jpg",
  "jpeg",
  "png",
  "mp4",
  "3gp",
  "mp3",
  "ogg",
  "m4a",
  "aac",
  "amr",
]);
